module.exports = __webpack_public_path__ + "img/btn_hot_confirm.2ea1b5bf.png";